import { BcAntenatalRadioTextboxField } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BcAntenatalRadioTextboxField";

class MedicalHistoryMentalHealth {
    public HasMentalHealth?: boolean = null;
    public HasAnxiety?: boolean = null;
    public HasDepression?: boolean = null;
    public HasPreviousPurifiedProteinDerivative?: boolean = null;
    public HasBipolar?: boolean = null;
    public HasEatingDisorder?: boolean = null;
    public HasSubstanceUseDisorder?: boolean = null;
    public HasMethadoneTreatment?: boolean = null;
    public HasSuboxoneTreatment?: boolean = null;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<MedicalHistoryMentalHealth>) {
        Object.assign(this, fields);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public hasSelectedAnyMedicalHistoryMentalHealth(): boolean {
        return this.HasAnxiety
            || this.HasDepression
            || this.HasPreviousPurifiedProteinDerivative
            || this.HasBipolar
            || this.HasEatingDisorder
            || this.HasSubstanceUseDisorder
            || this.Other.hasSelected();
    }

    public setSubstanceUseDisorder(): boolean {
        if (this.HasSubstanceUseDisorder != null)
            return this.HasSubstanceUseDisorder;

        return this.HasMethadoneTreatment
            || this.HasSuboxoneTreatment;
    }
}

export { MedicalHistoryMentalHealth };
